<template>
  <div>
    <Table
      resource="User"
      :actions="actions"
      :items="$store.getters['user/tableData']"
      :detail="$store.getters['user/detailData']"
      :fields="$store.getters['user/tableFields']"
      :pagination="$store.state.user.tablePagination"
      :keyword="$store.state.user.tableKeyword"
      :loading="$store.state.user.loadingTable"
      :filter="$store.state.user.tableFilter"
      :sort="$store.state.user.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'view',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('user/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('user/getDetail', id)
    },
    resetDetail() {
      this.$store.commit('user/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('user/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('user/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('user/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('user/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('user/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('user/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
